"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealChildFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealChildFilled = function MealChildFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 8a6 6 0 013.736 10.695c.173.743.264 1.514.264 2.305 0 6.075-5.373 11-12 11S8 27.075 8 21c0-.79.091-1.562.264-2.305a6 6 0 118.534-8.299A13.037 13.037 0 0120 10c1.11 0 2.183.138 3.203.396A5.989 5.989 0 0128 8zm-3.5 9a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-9 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM12 10a4 4 0 00-3.015 6.628c1.142-2.413 3.2-4.378 5.772-5.525A3.983 3.983 0 0012 10zm8 12c3.597 0 5.264 1.607 5.002 4.822l-.023.238a3 3 0 01-2.226 2.58c-.919.24-1.837.36-2.753.36-.784 0-1.569-.088-2.353-.263l-.392-.095a3 3 0 01-2.224-2.572C14.656 23.69 16.312 22 20 22zm0 2.5c-.673-.992-1.34-1.158-2-.5-.99.988.996 4 2 4s3.013-3 2-4c-.675-.667-1.342-.5-2 .5zM28 10a4 4 0 013.015 6.628c-1.142-2.413-3.2-4.378-5.773-5.525A3.986 3.986 0 0128 10z",
    fill: "#97BA1E"
  }));
};

exports.MealChildFilled = MealChildFilled;
var _default = MealChildFilled;
exports.default = _default;